import { StrictMode } from 'react';
import type { PropsWithChildren, ReactElement } from 'react';

/**
 * Wraps a client root's tree in `<React.StrictMode>` outside production
 * bundles.
 *
 * Everything StrictMode does — double-invoking renders, effects, state
 * updaters and ref callbacks, and warning about `UNSAFE_` lifecycles — exists
 * only in React's development build, so outside development the wrapper would be inert anyway; dropping
 * it keeps it out of the tree that ships. `__DEV__` and the development/
 * production React build are both derived from webpack's `optimizeBundle`,
 * so they cannot disagree about which one is in play.
 */
export default function StrictModeInDevelopment({
  children
}: PropsWithChildren<{}>): ReactElement {
  if (!__DEV__) {
    return <>{children}</>;
  }

  return <StrictMode>{children}</StrictMode>;
}
